import React from 'react'
import '../../../App.scss';
import Grid from "@material-ui/core/Grid";
import Button from "../../pageComponents/Settings/Free/Button";
import picoLogo from "../../../assets/images/pico_logo_small_size.png";

class PicoLoader extends React.Component {
    constructor() {
        super()
        this.state = {}
    }
    componentDidMount() {
    }
    render() {
        return(
            <Grid container xs={12} sm={12} className='pico-logo' alignItems={"center"} justify={"center"}>
                <img src={picoLogo} alt=""/>
            </Grid>
        )
    }
}
export default PicoLoader